import React from 'react'
import { useTranslation } from 'react-i18next'
import { Stack } from '../../../atoms/Stack'
import { Text } from '../../../atoms/Text'
import { Icon } from '../../../atoms/Icon'

interface SectionNotAvailableProps {
  sectionName: string
  title?: string
  description?: string
}

export const SectionNotAvailable: React.FC<SectionNotAvailableProps> = ({
  sectionName,
  title,
  description,
}) => {
  const { t } = useTranslation()

  return (
    <Stack
      align="center"
      justify="center"
      spacing="lg"
      style={{ padding: '48px' }}
    >
      <Icon name="lock" size="xl" color="secondary" />
      <Stack align="center" spacing="sm">
        <Text variant="h3" weight="bold">
          {title || t('common.section_not_shared', 'Section Not Shared')}
        </Text>
        <Text variant="body1" color="secondary" style={{ textAlign: 'center' }}>
          {description ||
            t(
              'common.section_not_shared_description',
              `The ${sectionName} section was not included in this shared analysis.`,
              { sectionName }
            )}
        </Text>
      </Stack>
    </Stack>
  )
}
